<template>
  <div class="equipmentDetail" :model="productList">
      <article class="eq-header" >
         <div class="detail-left">
            <img v-bind:src="productList.location" alt="">
         </div>
         <div class="detail-right">
            <h4>{{productList.title}}</h4>
            <ul>
              <li>产品规格：{{productList.specifications}}</li>
              <li>相机视野：{{productList.view}}</li>
              <li>平台秤：{{productList.platform}}</li>
              <li>支架：{{productList.bracket}}</li>
              <li>颜色：{{productList.colour}}</li>
              <li>说明：{{productList.explain}}</li>
            </ul>
         </div>
      </article>
      <h5 class="detailCan">产品详情</h5>
      <div class="hrs">
      </div>
      <article id="textC">
          <div>
             <h5 class="title-style">产品说明</h5>
             <p>{{productList.explain}}</p>
          </div>
          <div class="text-content">
              <h5>功能介绍</h5>
              <ul>
                <li v-for="item in productFunction">{{item}}</li>
              </ul>
          </div>
          <div class="text-content">
              <h5>产品配置</h5>
              <ul>
                <li v-for="item in productConfig">{{item}}</li>
              </ul>
          </div>
          <div class="text-content">
              <h5>参数说明</h5>
              <ul>
                <li v-for="item in productPrame">{{item}}</li>
              </ul>
          </div>
          <div class="text-content">
              <h5>接口方式</h5>
              <ul>
                <li v-for="item in productInterface">{{item}}</li>
              </ul>
          </div>
          <div class="text-content">
              <h5>产品特点</h5>
              <ul>
                <li v-for="item in productTrait">{{item}}</li>
              </ul>
          </div>
      </article>
      
  </div>
</template>

<script>
export default {
  name: 'equipmentDetail',
  props:["message","id"],
  data () {
    return {
      Index:this.message,
      shuo:'',
      productList:{
        remarks:'',
        title:'',
        describe:'',
        img_no:'',
        platform:'',
        view:'',
        specifications:'',
        bracket:'',
        colour:'',
        explain:'',
        introduce:'',
        config:'',
        table_height:'',
        max_size:'',
        random_code:'',
        decoding_speed:'',
        api_mode:'',
        characteristic:'',
        location:'',
        page_key:'',
        product_type:'',
        media_type:'',
        img_type:'',
        img_url:'',
        modify_date:'',
        create_date:'',
      },
      productFunction:[],//功能介绍
      productConfig:[],//产品配置
      productPrame:[],//参数说明
      productInterface:[],//接口方式
      productTrait:[],//产品特点
    }
  },
  created(){
      this.getProductList();
  },
  methods:{
     getProductList () {
      let self = this;
      const req = {
        index:1,
        size:10
      }
      this.$http.post('product/pageSelect/'+req.index+'/'+req.size,{id:self.id}).then((data)=>{
          data.body.data.forEach(element => {
                    
              self.img_url=element.location;
              self.productList.remarks = element.remarks
              self.productList.title = element.title
              self.productList.describe = element.describe
              self.productList.img_no = element.img_no
              self.productList.platform = element.platform
              self.productList.view = element.view
              self.productList.specifications = element.specifications
              self.productList.bracket = element.bracket
              self.productList.colour = element.colour
              self.productList.explain = element.explain
              self.productList.introduce = element.introduce
              self.productList.config = element.config
              self.productList.table_height = element.table_height
              self.productList.max_size = element.max_size
              self.productList.random_code = element.random_code
              self.productList.decoding_speed = element.decoding_speed
              self.productList.api_mode = element.api_mode
              self.productList.characteristic = element.characteristic

              self.productList.location = element.location
              self.productList.page_key = element.page_key
              self.productList.pzroduct_type = element.product_type
              self.productList.media_type = element.media_type
              self.productList.img_type = element.img_type
              self.productList.img_url = element.img_url
              self.productList.modify_date = element.modify_date
              self.productList.create_date = element.create_date



              var introduce = element.introduce+'';
              var config = element.config+'';
              var explain = element.explain+'';
              var api_mode = element.api_mode+'';
              var characteristic = element.characteristic+'';

              self.productFunction=introduce.split(";");
              self.productConfig=config.split(";");
              self.productPrame=explain.split(";");
              self.productInterface=api_mode.split(";");
              self.productTrait=characteristic.split(";");
          });

      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
*{
  text-align: left;
  /*text-indent: 6px;*/
  font-family: 微软雅黑;
  letter-spacing: 1px;
  color: #2D2D2D;
  font-size: 12px;
  line-height: 22px;
}
h4{
  font-size: 14px;
  font-weight: border;
  color: black;
}
ul li{
  list-style-type: none;
  vertical-align: right;
}

.hrs{
   width: 100%;
  margin: 0 auto;
  height:1px;
  border: 0;
  margin-bottom: 4px;
  background-color: #EEEEEE;
}
.eq-header{
  display: flex;
}
.eq-header .detail-left{
  flex: 1.3;
}

.eq-header .detail-right{
  flex: 2;
}
.detail-left img{
 width: 100%;
 height: 200px;
 margin-top: 20px;
 padding:4px;
 box-shadow: 0 0 2px rgba(0,0,0,.1);
}
.detail-right{
  padding-left: 25px;  
}

.detailCan{
  font-size: 13px;
}
.text-content{
  margin-bottom: 25px;
}
#textC .text-content h5{
  color: #162987;
}
#textC div:first-child p{
  margin-bottom: 25px;
}

</style>



// WEBPACK FOOTER //
// src/components/detail/equipmentDetail.vue